var map = {
	"./BlankLayout/index.layout.vue": "b788",
	"./EasyIeltsLayout/index.layout.vue": "d8a1",
	"./PlacementTestBusinessLayout/index.layout.vue": "7c63",
	"./PlacementTestLayout/index.layout.vue": "2a29",
	"./PlacementTestNewyearLayout/index.layout.vue": "c95f",
	"./PlacementTestSummerLayout/index.layout.vue": "c7b2",
	"./PlacementTestSurveyLayout/index.layout.vue": "0e14",
	"./PlacementTestXmasLayout/index.layout.vue": "803d",
	"./PrepareLayout/index.layout.vue": "7ff0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d1a";